// extracted by mini-css-extract-plugin
module.exports = {"Root":"App_Root__MvtI5","Instructions":"App_Instructions__DLonJ","Content":"App_Content__3tXGg","Data":"App_Data__3jz5C","Panels":"App_Panels__2ldAC"};